"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const twitter = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-twitter` : '') + (description ? ` desc-twitter` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-twitter"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-twitter"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 0C5.373 0 0 5.373 0 12C0 18.627 5.373 24 12 24C18.627 24 24 18.627 24 12C24 5.373 18.627 0 12 0Z",
    fill: "black"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M9.87105 6L13.2273 10.7796L17.4295 6H18.5763L13.7365 11.5046L19 19H15.1289L11.5845 13.9526L7.14688 19H6L11.0753 13.2276L6 6H9.87105ZM9.4348 6.86667H7.73333L11.6854 12.552L12.1821 13.2667L15.5652 18.1333H17.2667L13.1209 12.1694L12.6242 11.4549L9.4348 6.86667Z",
    fill: "white"
  }));
};
var _default = exports.default = twitter;